import { useAuth0 } from "@auth0/auth0-react";
import { useAppConfig } from "rwo-react";
import { LearningManagementClientV1 } from "../auto-generated-clients/learning-management-client-v1.generated";

let learningManagementClientV1: LearningManagementClientV1 | undefined;

export const useLearningManagementServiceV1 =
  (): LearningManagementClientV1 => {
    const { getAccessTokenSilently } = useAuth0();
    const { config } = useAppConfig();

    if (!learningManagementClientV1) {
      learningManagementClientV1 = new LearningManagementClientV1(
        `${config.BackendAddress}${config.LMSApiSuffix}`
      );
    }

    learningManagementClientV1.setAccessToken(getAccessTokenSilently());

    return learningManagementClientV1;
  };
